import { render, staticRenderFns } from "./ability_system.vue?vue&type=template&id=68135756&scoped=true"
import script from "./ability_system.vue?vue&type=script&lang=js"
export * from "./ability_system.vue?vue&type=script&lang=js"
import style0 from "./ability_system.vue?vue&type=style&index=0&id=68135756&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68135756",
  null
  
)

export default component.exports